import { useContext } from 'react';

import AuthContext from '../AuthContext';

export const useUserPages = () => useContext(AuthContext).userState.pages;
